/**
 * Helper functions for date field rendering.
 */

/**
 * Get a date string N days from now (YYYY-MM-DD format).
 */
export function getDateString(daysFromNow: number): string {
  const date = new Date();
  date.setDate(date.getDate() + daysFromNow);
  return date.toISOString().split("T")[0]; // YYYY-MM-DD
}

/**
 * Get a date string N days ago (YYYY-MM-DD format).
 */
export function getDateWorkedString(daysAgo: number): string {
  const date = new Date();
  date.setDate(date.getDate() - daysAgo);
  return date.toISOString().split("T")[0]; // YYYY-MM-DD
}
